export default "__VITE_ASSET__04fb4eab__"